import { flow } from 'lodash';
//@ts-ignore
import ReactMarkdown from 'react-markdown';
import 'katex/dist/katex.min.css';
//@ts-ignore
import RemarkMath from 'remark-math';
//@ts-ignore
import RemarkBreaks from 'remark-breaks';
//@ts-ignore
import RehypeKatex from 'rehype-katex';
//@ts-ignore
import RemarkGfm from 'remark-gfm';
//@ts-ignore
import RehypeRaw from 'rehype-raw';
import ThinkBlock from './think-block';
import Citation from './citation';
import ScriptBlock from './script';
import Link from './link';
// import Img from './img';
import Img from './components/Img';
import MobileImg from './components/MobileImg';
import cn from '../../utils/classnames';
import './markdown.scss';
import './plugin.scss';
import MindMap from '../MarkMap/MindMap';
import MobileMind from '../Mobile/MarkMap/MindMap';
import Code from './components/Code';
import { memo, useCallback } from 'react';
import CustomLink from './customLink';
import sanitizeHtml from '@/utils/sanitizeHtml';
const preprocessLaTeX = (content: string) => {
    //@ts-ignore
    if (typeof content !== 'string') return content;
    content = sanitizeHtml(content) as string;
    const codeBlockRegex = /```[\s\S]*?```/g;
    const codeBlocks = content.match(codeBlockRegex) || [];
    let processedContent = content.replace(codeBlockRegex, 'CODE_BLOCK_PLACEHOLDER');
    processedContent = flow([
        (str: string) => str.replace(/\\\[(.*?)\\\]/g, (_, equation) => `$$${equation}$$`),
        (str: string) => str.replace(/\\\[(.*?)\\\]/m, (_, equation) => `$$${equation}$$`),
        (str: string) => str.replace(/\\\((.*?)\\\)/g, (_, equation) => `$$${equation}$$`),
        (str: string) => str.replace(/(^|[^\\])\$(.+?)\$/g, (_, prefix, equation) => `${prefix}$${equation}$`)
    ])(processedContent);

    codeBlocks.forEach((block) => {
        processedContent = processedContent.replace('CODE_BLOCK_PLACEHOLDER', block);
    });

    return processedContent;
};

const preprocessThinkTag = (content: string) => {
    let hasThinkTag = content?.includes('<think>');
    const thinkOpenTagRegex = /<think>\n/g;
    const thinkCloseTagRegex = /\n<\/think>/g;
    const answerOpenTagRegex = /<answer>\n/g;
    const answerCloseTagRegex = /\n<\/answer>/g;
    return flow([
        (str: string) => str.replace(thinkOpenTagRegex, '<details data-think=true>\n'),
        (str: string) => str.replace(thinkCloseTagRegex, '\n[ENDTHINKFLAG]</details>')
        // (str: string) => str.replace(answerOpenTagRegex, `<div data-think=${hasThinkTag} class='ai-answer-box'>`),
        // (str: string) => str.replace(answerCloseTagRegex, '\n</div>')
    ])(content);
};
const Paragraph = (paragraph: any) => {
    const { node }: any = paragraph;
    const children_node = node.children;
    if (children_node && children_node[0] && 'tagName' in children_node[0] && children_node[0].tagName === 'img') {
        // 图片不使用p标签包裹，直接返回图片内容
        return <>{paragraph.children}</>;
    }
    return <p>{paragraph.children}</p>;
};

export function Markdown(props: {
    content: string;
    className?: string;
    customDisallowedElements?: string[];
    citation?: any;
    side?: string;
    thinkText?: string;
    thoughtText?: string;
}) {
    console.log(props.content,"====content=====");
    const { side } = props;
    const latexContent = flow([preprocessThinkTag, preprocessLaTeX])(props.content);
    // 用 useCallback 缓存 code 组件的渲染逻辑，避免每次渲染创建新函数
    const renderCode = useCallback(({ className, children }) => {
        const lang = className?.replace(/^language-/, '') || '';
        if (lang === 'mindmap') {
            return (
                <>
                    {side === 'web' ? (
                        <div style={{ width: 700 }}>
                            {/* 使用缓存后的 MindMap 组件 */}
                            {/* <MindMap content={content} /> */}
                            <MindMap content={children as any} />
                        </div>
                    ) : (
                        <MobileMind content={children as any}></MobileMind>
                    )}
                </>
            );
        }
        if (!lang) {
            return children;
        }
        // 其他语言的 code 块渲染逻辑

        return (
            <Code side={side} language={lang}>
                {String(children).replace(/\n$/, '')}
            </Code>
        );
    }, []); // 空依赖数组，确保函数引用稳定
    //传入的thinkText 会一直重新渲染，使用useCallback做缓存
    const renderDetail = useCallback((data) => {
        const { children, ...params } = data;

        return (
            <ThinkBlock {...params} thinktext={props?.thinkText} thoughttext={props?.thoughtText}>
                {children}
            </ThinkBlock>
        );
    }, []); // 空依赖数组，确保函数引用稳定
    return (
        <div className={cn('markdown-body', '!text-text-primary', props.className)}>
            <ReactMarkdown
                remarkPlugins={[
                    [RemarkGfm, { singleTilde: false, strikethrough: { singleTilde: false } }],
                    [RemarkMath, { singleDollarTextMath: true }],
                    RemarkBreaks
                ]}
                rehypePlugins={[
                    RehypeKatex,
                    RehypeRaw as any,
                    // The Rehype plug-in is used to remove the ref attribute of an element
                    () => {
                        return (tree: any) => {
                            const iterate = (node: any) => {
                                if (node.type === 'element' && node.properties?.ref) delete node.properties.ref;

                                if (node.type === 'element' && !/^[a-z][a-z0-9]*$/i.test(node.tagName)) {
                                    node.type = 'text';
                                    node.value = `<${node.tagName}`;
                                }

                                if (node.children) node.children.forEach(iterate);
                            };
                            tree.children.forEach(iterate);
                        };
                    }
                ]}
                disallowedElements={['iframe', 'head', 'html', 'meta', 'link', 'style', 'body', ...(props.customDisallowedElements || [])]}
                components={{
                    //@ts-ignore
                    img: side === 'web' ? Img : MobileImg,
                    a: Link,
                    p: Paragraph,
                    script: ScriptBlock as any,
                    details: renderDetail as any,
                    citation: (params: any) => {
                        return <Citation {...props.citation} {...params}></Citation>;
                    },
                    glink: (params: any) => {
                        return <CustomLink {...params} />;
                    },
                    code: renderCode as any
                }}
            >
                {/* Markdown detect has problem. */}
                {latexContent}
            </ReactMarkdown>
        </div>
    );
}
export const GrtAiMarkdown = memo(Markdown);
